import { gql } from '@apollo/client';

const QUERY_VIDEO_DOWNLOAD_INFO = gql`
  query VideoDownloadInfoQuery($id: ID!) {
    node(id: $id) {
      id
      __typename
      ... on Video {
        databaseId
        createdAt
        staticRenditions {
          __typename
          quality
          filesize
          url
        }
        project {
          id
          __typename
          name
        }
        tags(first: 15) {
          __typename
          edges {
            node {
              displayValue
            }
          }
        }
      }
    }
  }
`;

export default QUERY_VIDEO_DOWNLOAD_INFO;
